import React from 'react';
import { OverlapRow, formatINR, parseINR } from './overlap.constants';
import styles from './OverlapTooltipContent.module.scss';

interface Props {
    row: OverlapRow;
}

function OverlapTooltipContent({ row }: Props) {
    const { circularValue, circularPct, circularTotal } = row;

    const circularPctNum = circularPct != null ? parseFloat(circularPct) : NaN;
    const netPct = !isNaN(circularPctNum) ? `${(100 - circularPctNum).toFixed(1)}%` : null;

    const netValue = circularTotal && circularValue ? formatINR(parseINR(circularTotal) - parseINR(circularValue)) : '-';

    return (
        <div className={styles.Container}>
            <p className={styles.Title}>Circular Transaction Detected</p>

            <div className={styles.Rows}>
                <div className={styles.Row}>
                    <div className={styles.Labels}>
                        <span className={styles.Label}>Total</span>
                        {circularValue && (
                            <span className={styles.Label}>Circular{!isNaN(circularPctNum) ? ` (${circularPctNum.toFixed(1)}%)` : ''}</span>
                        )}
                    </div>
                    <div className={styles.Values}>
                        <span className={styles.ValueDefault}>{circularTotal || '-'}</span>
                        {circularValue && <span className={styles.ValueRed}>{circularValue}</span>}
                    </div>
                </div>

                <div className={styles.Divider} />

                <div className={styles.Row}>
                    <span className={styles.Label}>Net{netPct != null ? ` (${netPct})` : ''}</span>
                    <span className={styles.ValueBold}>{netValue}</span>
                </div>
            </div>
        </div>
    );
}

export default OverlapTooltipContent;
